import React, { useState } from 'react';
import { Button } from './ui/button';
import { Download } from 'lucide-react';
import api from '../lib/api';
import { toast } from 'sonner';

const ExportButton = ({ entity, label }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format) => {
    setExporting(true);
    try {
      const response = await api.get(`/export/${entity}`, {
        params: { format },
        responseType: 'blob'
      });
      const blob = new Blob([response.data], {
        type: format === 'csv' ? 'text/csv' : 'application/json'
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${entity}_export_${new Date().toISOString().slice(0, 10)}.${format}`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`${label || entity} exported as ${format.toUpperCase()}`);
    } catch {
      toast.error('Export failed');
    }
    setExporting(false);
  };

  return (
    <div className="flex gap-1">
      <Button variant="outline" size="sm" onClick={() => handleExport('csv')} disabled={exporting} data-testid={`export-${entity}-csv`}>
        <Download className="w-3.5 h-3.5 mr-1.5" />CSV
      </Button>
      <Button variant="outline" size="sm" onClick={() => handleExport('json')} disabled={exporting} data-testid={`export-${entity}-json`}>
        <Download className="w-3.5 h-3.5 mr-1.5" />JSON
      </Button>
    </div>
  );
};

export default ExportButton;
